import { CpoType } from 'types_/state/permission';

export function generateCpoRoutePath(url: string | undefined, operator: CpoType) {
  if (!url) return '';
  return `/cpo/${operator._id}${url}`;
}
